import IdVerification from 'ui/sections/notarize/pages/id-verification/IdVerification';
import { NotarizationStatus } from 'utils/enums';

export default class SpouseIdVerification extends IdVerification {
  static forSpouse = true;
  static notarizationSection = NotarizationStatus.ID_VERIFICATION_SPOUSE;
}
